/** Current SmartWatcher catalog plan ids (plus trial). */
const ATS_PLANS = new Set([
  'pro',
  'pro-and-voice',
  'trial',
]);

const VOICE_AI_PLANS = new Set([
  'essential-and-voice',
  'pro-and-voice',
  'trial',
]);

/** Prioritize / AI call queue — paid Voice AI bundles only (not trial). */
const PRIORITIZE_PLANS = new Set([
  'essential-and-voice',
  'pro-and-voice',
]);

const TOP_TIER_PLANS = new Set([
  'pro',
  'pro-and-voice',
]);

export const normalizePlanId = (plan) => (plan ?? '').trim().toLowerCase();

export const planHasAtsIntegration = (plan) => ATS_PLANS.has(normalizePlanId(plan));

export const planHasVoiceAI = (plan) => VOICE_AI_PLANS.has(normalizePlanId(plan));

export const planCanPrioritize = (plan) => PRIORITIZE_PLANS.has(normalizePlanId(plan));

/** Pro / Pro + Voice — highest candidate limits; no “upgrade plan” hint at limit. */
export const planIsTopTier = (plan) => TOP_TIER_PLANS.has(normalizePlanId(plan));
